<template>
	<div class="edit_wrap">
		<div class="edit_top">
			<div class="edit_tab">供应商信息</div><!--
    --><div class="edit_tab">品牌信息</div><!--
    --><div class="edit_tab active_tab">财务信息</div><!--
    --><div class="edit_tab">合同协议</div>
		</div>
		<div class="tip_word">
			<el-row>
				<el-col :span="2">
					<div class="grid-content">友情提示：</div>
				</el-col>
				<el-col :span="22"><div class="grid-content f12 f666 lh20">1.请按照大V服务平台信息要求填写正确的供应商信息。</div></el-col>
			</el-row>
			<el-row>
				<el-col :span="22" :offset="2"><div class="grid-content f12 f666 lh20">2.所有资质信息格式要求：复印件加盖公司红章之后，再扫描上传到大V服务平台。请确保证件内容清晰可见，扫描件大小不得超过1M。</div></el-col>
			</el-row>
			<el-row>
				<el-col :span="22" :offset="2"><div class="grid-content f12 f666 lh20">3.提交审核之后，大V店工作人员会在3个工作日内进行审核。</div></el-col>
			</el-row>
			<el-row>
				<el-col :span="22" :offset="2"><div class="grid-content f12 f666 lh20">4.入驻过程有任何疑问，请按照如下方式解决：<br>（1）如果有对接的采销，请直接联系采销处理解决；<br>（2）如果还未对接采销，直接发送问题至邮箱：bd@davdian.com 。</div></el-col>
			</el-row>
			<el-row>
				<el-col :span="22" :offset="2"><div class="grid-content f12 f666 lh20">5.<a target="_blank" href="/suppliers/index2/#/intro"><span style="color: #58b7ff">点击此处</span></a>查看供应商入驻介绍。</div></el-col>
			</el-row>
		</div>
		<div class="pl10 mt20">
			<span class="dib">税务信息</span><span class="line"></span>
			<div class="mt20">
				<el-form :model="finalForm" :rules="rules" ref="finalForm" label-width="207px" class="demo-ruleForm">

					<!-- 纳税人识别号 -->
					<el-form-item label="纳税人识别号：" prop="taxpayerRegistrationCode">
						<el-input class="w500" v-model="finalForm.taxpayerRegistrationCode" placeholder="请输入纳税人识别号"></el-input>
					</el-form-item>
					<!-- 纳税人类型 -->
					<el-form-item label="纳税人类型：" class="mt20">
						<span class="main_word rule_star105">*</span>
						<el-radio-group class="ml_10" v-model="finalForm.taxpayerType" @change="typeChange" :disabled="applyStatus == 9">
							<el-radio :label="1"><span class="f14 f666">一般纳税人</span></el-radio>
							<el-radio :label="2"><span class="f14 f666">小规模纳税人</span></el-radio>
						</el-radio-group>
					</el-form-item>
					<!-- 一般纳税人资格认定表 -->
					<el-form-item v-show="isList" label="一般纳税人资格认定表：" class="mt20">
						<span class="main_word rule_star178">*</span>
						<span class="f666 f12 ml_10">复印件需加盖公司红章扫描上传</span>
						<el-upload action="/suppliers/uploadImages?biz=0" :file-list="finalForm.file"
								   list-type="picture-card" name="pic" :before-upload="beforeUpload" :on-preview="handlePictureCardPreview"
								   :on-success="handleUpload" :on-remove="handleRemoveGeneralTaxpayerFile">
							<i class="el-icon-plus"></i>
						</el-upload>
						<el-dialog :visible.sync="dialogVisible" size="small">
							<img width="100%" :src="dialogImageUrl" alt="">
						</el-dialog>
						<span class="f999 f12">上传电子版资质仅支持JPG、GIF、PNG等格式的图片，大小不超过1M，可上传多张</span>
						<p v-show="pic_1" class="pic_tip">请上传图片</p>
					</el-form-item>
					<span class="dib">货款支付账户</span><span class="second_line"></span>
					<!-- 银行开户名 -->
					<el-form-item class="mt20" label="银行开户名：" prop="accountName">
						<el-input class="w500" v-model="finalForm.accountName" placeholder="请输入银行开户名"></el-input>
					</el-form-item>
					<!-- 银行帐号 -->
					<el-form-item label="银行帐号：" prop="accountNumber">
						<el-input class="w500" v-model="finalForm.accountNumber" placeholder="请输入银行帐号"></el-input>
					</el-form-item>
					<!-- 开户银行 -->
					<el-form-item label="开户银行：" prop="bankName">
						<el-input class="w500" v-model="finalForm.bankName" placeholder="请输入开户银行"></el-input>
					</el-form-item>

					<el-form-item v-if="finalForm.registeredCountry != 1" label="SwiftCode："  class="mt20">
						<span class="main_word rule_star100">*</span>
						<el-input class="w500 ml_10" v-model="finalForm.swiftCode" placeholder="请输入SwiftCode" :maxlength="35"></el-input>
					</el-form-item>
					<!-- 省份 -->
					<el-form-item v-if="finalForm.registeredCountry == 1" label="省：">
						<span class="main_word rule_star50">*</span>
						<el-input class="w500" v-model="finalForm.province" placeholder="请输入省"></el-input>
					</el-form-item>
					<!-- 城市 -->
					<el-form-item v-if="finalForm.registeredCountry == 1" label="市：">
						<span class="main_word rule_star50">*</span>
						<el-input class="w500" v-model="finalForm.city" placeholder="请输入市"></el-input>
					</el-form-item>

					<!-- 操作 -->
					<el-form-item class="mt50 mb50" label-width="207px">
						<el-button type="primary" class="mr10" @click="goBrand">上一页</el-button>
						<el-button v-if="applyStatus == 0 || applyStatus==1" type="primary" class="mr10" @click="saveForm">保存草稿</el-button>
						<el-button v-if="applyStatus == 0 || applyStatus==1" type="primary" @click="submitForm('finalForm')">提交审核</el-button>
						<el-button v-if="applyStatus == 3 || applyStatus==9" type="primary" @click="submitForm('finalForm')">重新提交审核</el-button>
					</el-form-item>

				</el-form>
			</div>
		</div>
	</div>

</template>

<script type="text/javascript">
	export default {
		data () {
			return {
                applyStatus:0,
				supplierApplyId: null,
				// 认定表
				isList: true,
				// 预览图片弹框
				dialogVisible: false,
				// 验证是否上传图片 提示
				pic_1: false,
				// 预览图片 url
				dialogImageUrl: '',
				// 财务信息数据
				finalForm: {
					bankAccountId: '',  // 银行账户id,可为空,如果为空则创建新账户，不为空则更新账户
					taxpayerRegistrationCode: '',
					taxpayerType: 1,
					accountName: '',
					accountNumber: null,
					bankName: '',
                    swiftCode: '',
                    province: '',
                    city: '',
					// 一般纳税人资格认定表
					file: [
					],
				},

				// 验证
				rules: {
					taxpayerRegistrationCode: [
						{ required: true, message: '请输入纳税人识别号', trigger: 'blur' }
					],
					accountName: [
						{ required: true, message: '请输入银行开户名', trigger: 'blur' },
						{ max: 50, message: '请输入50字符以内', trigger: 'blur' }
					],
					accountNumber: [
						{ required: true, message: '请输入银行帐号', trigger: 'blur' },
                        { max: 30, message: '请输入30字符以内', trigger: 'blur' }
					],
					bankName: [
						{ required: true, message: '请输入开户银行', trigger: 'blur' }
					]
				}
			}
		},
		methods: {
			fetch () {
				var _this = this;
				$.get({
					url: '/suppliers/supplierSettled/findFinancialInfo',
					data: {
						supplierApplyId: _this.supplierApplyId
					},
					success: function (result) {
						if (!result.code) {
                            var status = result.data.status;
                            _this.applyStatus = status;
                            if(status!=1 && status!=3 && status!=9) {
                                if(status == 5) {
                                    // 后台成功 改变路由
                                    _this.$router.push({
                                        path:'/supplier_apply_audit',
                                        query:{supplierApplyId: supplierApplyId}
                                    })
                                }else{
                                    // 后台成功 改变路由
                                    _this.$router.push({
                                        path:'/supplier_skan',
                                        query:{supplierApplyId: supplierApplyId}
                                    })
                                }
                            }
							_this.finalForm = result.data;
                            _this.finalForm.file = _this.fileTrans(_this.finalForm.generalTaxpayerFile);
							_this.pic_1 = false;
						} else if(result.code == 10067) {
                            window.location.href = "/suppliers/index";
                        } else {
							 _this.$message({
							   showClose: true,
							   message: result.msg,
							   type: 'error'
							 });
						}
					}
				})
			},

			// 预览 一般纳税人资格认定表 图片
			handlePictureCardPreview(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisible = true;
			},

            handleUpload (response) {
                if (!response.code) {
                    this.finalForm.file.push({url: response.data});
                    if (this.finalForm.file.length > 0) {
                        this.pic_1 = false;
                    } else {
                        this.pic_1 = true;
                    }
                } else {
                    this.$message({
                        showClose: true,
                        message: response.msg,
                        type: 'error'
                    });
                }
            },

            // 纳税人类型 变化
            typeChange (value) {
                if (value == 2) {
                    this.isList = false;
                } else {
                    this.isList = true;
                }
                console.log(value)
            },

            fileTrans(fileUrl){
                var array = [];
                if (fileUrl) {
                    var files = fileUrl.split(',');
                    for (var i = 0; i < files.length; i++) {
                        var file = {};
                        file.url = files[i];
                        console.log(file);
                        array.push(file);
                    }
                }
                return array;
            },
            // 保存草稿
            saveForm () {
                var _this = this;
                var Data = {};
                Data = JSON.parse(JSON.stringify(this.finalForm));
                if (Data.taxpayerType == 1) {
                    if (this.finalForm.file.length > 0) {
                        Data.generalTaxpayerFiles = _this.fileTransToArray(this.finalForm.file);
                    }
                }
                Data.supplierApplyId = _this.supplierApplyId;
                $.ajax({
                    url: '/suppliers/supplierSettled/saveFinancialInfo',
                    data: JSON.stringify(Data),
                    dataType: "json",
                    contentType: 'application/json;charset=utf-8',
                    type: 'POST',
                    success: function (result) {
                        if (!result.code) {
                            _this.$message({
                                message: '成功保存草稿',
                                type: 'success'
                            });
                        } else {
                            _this.$message({
                                showClose: true,
                                message: result.msg,
                                type: 'error'
                            });
                        }
                    }
                })
            },

            submitForm(formName) {
                var _this = this;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        console.log('submit!');
                        var _this = this;
                        var Data = {};
                        Data = JSON.parse(JSON.stringify(this.finalForm));
                        if (Data.taxpayerType == 1) {
                            if (this.finalForm.file.length > 0) {
                                Data.generalTaxpayerFiles = _this.fileTransToArray(this.finalForm.file);
                            } else {
                                this.$message.error('请上传一般纳税人资格认定表');
                                return;
                            }
                        }

                        if (_this.finalForm.registeredCountry != 1) {
                            if (!_this.finalForm.swiftCode) {
                                this.$message.error('请输入SwiftCode');
                                return;
							}
						}

                        if (_this.finalForm.registeredCountry == 1) {
                            if (!_this.finalForm.province) {
                                this.$message.error('请输入省');
                                return;
                            }
                        }

                        if (_this.finalForm.registeredCountry == 1) {
                            if (!_this.finalForm.city) {
                                this.$message.error('请输入市');
                                return;
                            }
                        }

                        Data.supplierApplyId = _this.supplierApplyId;
                        $.ajax({
                            url: '/suppliers/supplierSettled/submitFinancialInfo',
                            data: JSON.stringify(Data),
                            dataType: "json",
                            contentType: 'application/json;charset=utf-8',
                            type: 'POST',
                            success: function (result) {
                                if (!result.code) {
                                    // 后台成功 改变路由
                                    _this.$router.push({
                                        path: './supplier_skan?supplierApplyId=' + _this.supplierApplyId
                                    })
                                } else {
                                    _this.$message({
                                        showClose: true,
                                        message: result.msg,
                                        type: 'error'
                                    });
                                }
                            }
                        })
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            // 图片 转化成 数组
            fileTransToArray(files){
                var fileArray = [];
                if (files) {
                    for (var i = 0; i < files.length; i++) {
                        if (files[i].url) {
                            fileArray.push(files[i].url);
                        }
                    }
                }
                return fileArray;
            },

			// 返回品牌列表
			goBrand () {
                var _this = this;
                this.$confirm('此操作将不保存数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$router.push({
                        path:'/edit_info_brand?supplierApplyId=' + _this.supplierApplyId
                    })
                }).catch(() => {
                    console.log("取消")
                });
			},

            // 删除 上传图片 一般纳税人认定表
            handleRemoveGeneralTaxpayerFile(file, fileList) {
                var _this = this;
                console.log(file, fileList);
                var picFiles = [];
                for (var i = 0; i < fileList.length; i++) {
                    var curPicFile = fileList[i];
                    picFiles.push(curPicFile);
                }
                _this.finalForm.file = picFiles;
            },

			beforeUpload (file) {
                const isJPG = (file.type === 'image/jpeg') || (file.type === 'image/png') || (file.type === 'image/gif') || (file.type === 'image/jpg');
				console.log(isJPG)
				const isLt1M = file.size / 1024 / 1024 < 1;
				if (!isJPG) {
					this.$message.error('上传图片只能是JPG、GIF、PNG等格式的图片格式!');
					return isJPG;
				}

				if (!isLt1M) {
					this.$message.error('上传图片大小不能超过 1MB!');
					return isLt1M;
				}
			}
		},

		mounted () {
			this.supplierApplyId = sessionStorage.getItem("supplierApplyId");
			this.fetch();
		},

        watch: {

        }
	}
</script>

<style type="text/css" lang="less" scoped>
	.line {
		margin-left: 3%;
		display: inline-block;
		width: 91%;
		height: 1px;
		border-bottom: 1px dashed #999;
		vertical-align: middle;
	}
	.second_line {
		margin-left: 3%;
		display: inline-block;
		width: 88%;
		height: 1px;
		border-bottom: 1px dashed #666;
		vertical-align: middle;
	}
	.pic_tip {
		font-size: 12px;
		color: #ff4949;
		line-height: 1px;
		padding-top: 4px;
    position: absolute;
    top: 100%;
    left: 0;
	}
	.edit_wrap {
		width: 1050px;
		margin: 50px auto;
		border: 1px solid #eee;
	.edit_tab {
		display: inline-block;
		width: 262px;
		height: 46px;
		text-align: center;
		line-height: 46px;
		color: #fff;
		background: #ff6c83;
	}
	.active_tab {
		background: #ff4a7d;
	}
	.tip_word {
		margin-top: 20px;
		width: 1048px;
		height: 160px;
		background: #f9f9f9;
		padding: 10px;
	}
	}
	.rule_star105 {
		position: relative;
		left:-105px;
	}
	.rule_star178 {
		position: relative;
		left:-178px;
	}
	.ml_10 {
		margin-left: -10px;
	}
	.lh20 {
		line-height: 20px;
	}
	.rule_star100 {
		position: relative;
		left:-100px;
	}
	.rule_star50 {
		position: relative;
		left:-50px;
	}
</style>


// WEBPACK FOOTER //
// financeInfo.vue?243389f3